var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_76_867",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_76_867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3 17.2998L8.69999 12.6998C8.59999 12.5998 8.52932 12.4915 8.48799 12.3748C8.44599 12.2581 8.42499 12.1331 8.42499 11.9998C8.42499 11.8665 8.44599 11.7415 8.48799 11.6248C8.52932 11.5081 8.59999 11.3998 8.69999 11.2998L13.3 6.6998C13.4833 6.51647 13.7167 6.4248 14 6.4248C14.2833 6.4248 14.5167 6.51647 14.7 6.6998C14.8833 6.88314 14.975 7.11647 14.975 7.3998C14.975 7.68314 14.8833 7.91647 14.7 8.0998L10.8 11.9998L14.7 15.8998C14.8833 16.0831 14.975 16.3165 14.975 16.5998C14.975 16.8831 14.8833 17.1165 14.7 17.2998C14.5167 17.4831 14.2833 17.5748 14 17.5748C13.7167 17.5748 13.4833 17.4831 13.3 17.2998Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.41994bb89b9e07ce9f3b156cc992b618.svg";
export { ForwardRef as ReactComponent };